// import { EmployeeList } from "components/Employee";

import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { EmployeeList } from "../../components/EmployeeList";
import { FC } from "react";
import { PayrollProvincialEarningList } from "../../components/PayrollProvincialEarningList/PayrollProvincialEarningList";

export interface IPayrollProvincialEarningsListPage {}

export const PayrollProvincialEarningsListPage: FC<IPayrollProvincialEarningsListPage> = (
  props: IPayrollProvincialEarningsListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll Provincial Earning"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "", navigateTo: "/payroll-Provincial-earning/list" },
      ]}
      mainContents={<PayrollProvincialEarningList />}
    />
  );
};
